import classes from './sceErrorBox.scss';

const ScePasswordErrorDisplay = function (props) {
  const errDet = props && props.errDetails ? props.errDetails : [];
  const errValDispMsgs = errDet.map((errField) => {
    const validityMark = !errField.isError ? <span aria-atomic>
      <i aria-hidden className='fas fa-square-full fa-xs' />
      <span className="sr-only">Fail</span>
    </span> : <span>
      <i aria-hidden className='fas fa-check' />
      <span className="sr-only">Pass</span>
    </span>;
    return (<li id={errField.id}>
      {validityMark}
      <span>{app.appUtil.t(errField.validMsg)}</span>
    </li>);
  });
  return (
    <div className={classes.scePwdErrSpacing}  role='region' aria-live='polite'>
      <div>{app.appUtil.t('Password must include at least:')}</div>
      <ul className={classes.scePwdCheck} >
        {errValDispMsgs}
      </ul>
    </div>);
};

export default ScePasswordErrorDisplay;


